import HtmlFrame from "./T2";
import { Routes, Route } from "react-router-dom";
function Weedings3() {
    return (
        <Routes>
            <Route path="/" element={<HtmlFrame />}>
            </Route>
        </Routes>
    )
}
export default Weedings3;
